import {
	getController,
	apiService as Service,
	type HpRequestOptional,
} from '@/services/service'

const url = 'cis'
export const cisService = {
	...getController<Api.Cis, Api.CisPostInput, Api.CisUpdateInput>(url),
	show: (id: number, data?: HpRequestOptional) =>
		Service.get({
			url: `${url}/${id}?rel=["units", "persons", "buildings", "records", "craftsman_tasks", "documents", "documents.document_files"]`,
			...data,
		}),
}

export default cisService
